import React, { useEffect, useState, useContext} from "react";
import { Link } from 'react-router-dom'
import SearchBox from "../../customer/components/SearchBox";
import Scroll from "../../shared/components/navigation/Scroll";
import Table from "../../shared/components/Table/Table";
import ErrorModal from "../../shared/components/UIElements/ErrorModal";
import FloatingButton from "../../shared/components/UIElements/FloatingButton";
import LoadingSpinner from "../../shared/components/UIElements/LoadingSpinner";
import { useHttpClient } from "../../shared/hooks/http-hook";
import { ConsignmentTableHeaders, ConsignmentMobileTableHeaders } from "../components/ConsignmentTableHeaders";
import { AuthContext } from '../../shared/context/auth-context';
import { useWindow } from '../../shared/hooks/window-hook';

import './Consignments.css'
const Consignments = () => {
  const auth = useContext(AuthContext);
  const [consignments, setConsignments] = useState([]);
  const [searchfield, setSearchfield] =useState("")
  const { isLoading, error, sendRequest, clearError } = useHttpClient();
  const [options, setOption] = useState("DEFAULT");
  const { width } = useWindow();

  useEffect(() => {
    const fetchConsignments = async () => {
      let responseData;
      try {
        responseData = await sendRequest(
          process.env.REACT_APP_BACKEND_URL+ "/consignments", 
          "GET" , 
          null,
          {Authorization: 'Bearer '+ auth.token}
        );
        setConsignments(responseData.consignments);
      } catch (err) { }
    };
    fetchConsignments();
  }, [sendRequest, auth.token]);

const filteredConsinments = consignments.map(consignment => {
  return({...consignment, style : consignment.style.split("_")[0]})
})
.filter((consignment) => {
return(
    consignment.style.toLowerCase().includes(searchfield.toLowerCase() ) ||
    consignment.company.toLowerCase().includes(searchfield.toLowerCase()) ||
    consignment.color.toLowerCase().includes(searchfield.toLowerCase()) ||
    consignment.USSize.toLowerCase().includes(searchfield.toLowerCase()) ||
    consignment.EURSize.toLowerCase().includes(searchfield.toLowerCase()) ||
    String(consignment.quantity).includes(searchfield) ||
    String(consignment.cost).includes(searchfield)||
    String(consignment.price).includes(searchfield)
  )
})
.filter((consignment ) => {
  return(
    options === "DEFAULT" ? consignment.company :  consignment.company ===  options); 
}).reverse();

const onSearchChange =(event)=>{
  setSearchfield(event.target.value);
};

const ConsignmentSet = new Set();
consignments && consignments.forEach(consignment => {
      ConsignmentSet.add(consignment.company);  
}) 


const onChangeHandler = (event) => {
  setOption(event.target.value);
}; 
  return (
    <React.Fragment>
      <ErrorModal error={error} onClear={clearError} />
      {isLoading && (
        <div className="center">
          <LoadingSpinner />
        </div>
      )}
      <div className="flex justify-between">
        <div className=" w-25 pa3">
            <div className="show-checkbox">
            <label>
              <select onChange={onChangeHandler} defaultValue={'DEFAULT'} className="pa2 bg-light-gray br3">
              <option value="DEFAULT" >Choose a company ...</option>
                {Array.from(ConsignmentSet).map(option => 
                <option key={option} value={option}>{option}</option>)}            
              </select>
            </label>
          </div>
        </div>
        <div className=" w-25 pa3">
        </div>
        <div className=" w-25 pa3 tc f3">
          <code> <Link to="/sendBacks">SEND BACK</Link></code>
        </div>
      </div>

     
      <div className="tc">
        <div style={{ display: "inline-block" }}>
          <SearchBox searchChange={onSearchChange} />
        </div>
      </div>
      <Scroll>
        {!isLoading && filteredConsinments && (
          <Table
            headers={width > 800 ? ConsignmentTableHeaders : ConsignmentMobileTableHeaders}
            content={filteredConsinments}
          />
        )}
      </Scroll>
      <FloatingButton route={"/consignments/new"} />
    </React.Fragment>
  );
};

export default Consignments;
